<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    name?: string
    description?: () => string
    box?: boolean
    showChannel?: boolean
    classes?: string
  }>(),
  {
    box: true,
  },
)

provide('insideBox', props.box)

const channel = useChannel()
const store = useStore()

const channelName = computed(
  () => store.channels.find((item) => item.id === channel.value)?.name,
)
</script>

<template>
  <section class="relative mb-6">
    <div class="">
      <div class="flex justify-between items-center">
        <div v-if="name || description" class="lg:col-span-1 mb-4 px-4 md:px-0">
          <h2 v-if="name" class="text font-medium text-gray-900">
            <span>{{ name }}</span>
            <span v-if="showChannel" class="text-gray-400 text-sm ml-2">{{
              channelName
            }}</span>
          </h2>
          <p
            v-if="description"
            class="mt-1 text-sm text-gray-500"
            v-html="
              typeof description === 'string' ? description : description()
            "
          />
        </div>
      </div>
      <div
        v-if="box"
        class="grid gap-3 mt-5 lg:mt-0 lg:col-span-2 bg-white px-4 py-5 md:px-6 md:pb-6 md:pt-5 ring-1 ring-black ring-opacity-5 shadow md:rounded-lg"
      >
        <slot />
      </div>
      <template v-else>
        <div v-if="classes" :classes="classes">
          <slot />
        </div>
        <slot v-else />
      </template>
    </div>
  </section>
</template>
